import { useTranslation } from "react-i18next";
import AppStoreBadges from "@/components/landing/AppStoreBadges";
import QrCard from "./QrCard";
import { SOCIAL_LINKS } from "./socialLinks";
import { focusRingDark } from "./styles";
import logoWhite from "@/assets/logo-white.png";

/** The one deep-forest band on the page. */
const FinalCTA = () => {
  const { t } = useTranslation();
  return (
    <section
      id="download"
      aria-labelledby="cta-h"
      className="scroll-mt-[72px] bg-pf-forest px-[22px] py-[clamp(96px,10vw,140px)] text-center text-white"
    >
      <div className="pf-rv mx-auto max-w-[880px]">
        <img
          src={logoWhite}
          alt=""
          width={204}
          height={283}
          loading="lazy"
          decoding="async"
          className="mx-auto mb-8 block h-14 w-auto"
        />
        <h2
          id="cta-h"
          className="text-balance text-[clamp(48px,7.4vw,104px)] font-bold leading-none tracking-[-0.04em] text-white"
        >
          {t("home.cta.title")}
        </h2>
        <p className="mt-4 text-[clamp(24px,2.6vw,34px)] font-semibold tracking-[-0.02em] text-pf-sage">
          {t("home.cta.subtitle")}
        </p>
        <div className="mt-10 flex flex-wrap items-center justify-center gap-3.5">
          <AppStoreBadges variant="pill-inverse" align="center" location="final_cta" utmCampaign="home_clarity" />
          <QrCard bordered={false} />
        </div>

        <div className="mt-14 flex flex-wrap items-center justify-center gap-4 border-t border-white/15 pt-8">
          <span className="text-[15px] font-medium text-pf-sage-soft">{t("home.cta.follow")}</span>
          <ul className="m-0 flex list-none gap-2.5 p-0">
            {SOCIAL_LINKS.map(({ name, href, Icon }) => (
              <li key={name}>
                <a
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={t("home.social.ariaLabel", { network: name })}
                  className={`flex h-11 w-11 items-center justify-center rounded-full border border-white/30 text-white transition-colors hover:border-white/60 hover:bg-white/10 ${focusRingDark}`}
                >
                  <Icon />
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
